import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  '& MuiPaper-root': {
    width: '100%',
    '& .MuiPopover-paper': {
      width: '100% !important'
    }
  },

  root: {
    '& .MuiCardHeader-content span': {
      color: theme.palette.blue_300.main,
      fontWeight: '500'
    }
  },

  mainHeaderContainerMobile: {
    display: 'flex',
    alignItems: 'center',
    background:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gradient.main, //
    // padding: '4px 10px',
    width: '100%',
    height: 70,
    boxSizing: 'border-box'
  },

  cardHeader: {
    flex: 1,
    padding: 0,
    color: '#fff',
    '& .MuiCardHeader-avatar': {
      marginRight: '12px'
    }
  },
  contactName: {
    fontWeight: 'bold',
    fontSize: '1rem',
    color: '#fff'
  },
  contactPhone: {
    fontSize: '0.8rem',
    color: 'rgba(255, 255, 255, 0.8)'
  },
  backButton: {
    marginRight: 4,
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main
    }
  },
  whatsappBadge: {
    position: 'absolute',
    top: 38,
    left: 65,
    zIndex: 999,
    borderRadius: '50%',
    backgroundColor: theme.palette.green_200.main,
    width: 20,
    height: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  actionButton: {
    marginLeft: 'auto'
  },
  boxAvatar: {
    height: '100%',
    positon: 'relative'
  },
  cardAvatar: {
    width: '55px',
    height: '55px',
    cursor: 'pointer',
    '& .MuiCardHeader-content span': {
      color: theme.palette.blue_300.main,
      fontWeight: '500'
    },
    [theme.breakpoints.down('lg')]: {
      width: '45px',
      height: '45px'
    },
    [theme.breakpoints.up('lg')]: {
      width: '55px',
      height: '55px'
    }
  },
  cardTitle: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontWeight: '600',
    fontSize: '.875rem',
    cursor: 'pointer',
    maxWidth: '400px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('lg')]: {
      fontSize: '1rem',
      maxWidth: '500px'
    },
    [theme.breakpoints.down('sm')]: {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main
    }
  },
  ticketID: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontWeight: '500',
    fontSize: '.8rem',
    [theme.breakpoints.down('sm')]: {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main
    }
  },
  ticketUser: {
    color: theme.palette.blue_300.main,
    fontWeight: '500',
    fontSize: '.75rem',
    marginTop: '2px'
  },
  ticketQueue: {
    color: theme.palette.green_300?.main || theme.palette.blue_300.main,
    fontWeight: '500',
    fontSize: '.75rem',
    marginTop: '2px'
  },
  ticketStatus: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_stroke.main,
    fontWeight: '500',
    fontSize: '.75rem',
    marginTop: '2px'
  },
  cardSubHeader: {
    display: 'flex',
    flexDirection: 'column'
  },
  infoSubHeader: {
    display: 'flex',
    gap: '8px'
  },
  infoSubHeaderTitle: {
    color: theme.palette.gray_400.main
  },

  cardTags: {
    display: 'flex',
    width: '100%',
    height: '30px',
    marginTop: '8px'
  },
  cardBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  badgeItem: {
    borderRadius: '4px',
    fontSize: '12px',
    height: '20px',
    color: theme.palette.white_100.main
  },
  badgeSelect: {
    backgroundColor: theme.palette.gray_50.main,
    color: theme.palette.gray_400.main,
    '& .MuiOutlinedInput-input': {
      padding: '4px 10px'
    },
    '& .MuiSelect-icon': {
      display: 'none' // Oculta o ícone
    }
  },
  addNewTag: {
    '& button': {
      display: 'flex',
      gap: '4px',
      color: theme.palette.blue_300.main,
      borderRadius: '4px',
      padding: '4px 8px',
      fontSize: '1rem',
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.blue_400.main
      }
    }
  }
}))
